import { SessionCategoryIconsBasePath } from "../../constants/paths";
import { SessionCategoryCreateDto } from "../../dto/sessions/session-category-create.dto";
import { SessionCategoryUpdateDto } from "../../dto/sessions/session-category-update.dto";
import { SessionCategoryDto } from "../../dto/sessions/session-category.dto";
import { SessionCategory, SessionCategoryBase} from "../../models/sessions/session-category.model";
import { ImageAssetMapper } from "../media/cover.mapper";

const sessionCategoryStyling = [
  { id: 'focus', image: `${SessionCategoryIconsBasePath}/Circle.svg`, backgroundColor: 'rgba(84, 88, 247, 0.1)' },
  { id: 'stress', image: `${SessionCategoryIconsBasePath}/RainbowCloud.svg`, backgroundColor: 'rgba(47, 225, 172, 0.1)' },
  { id: 'tension', image: `${SessionCategoryIconsBasePath}/Spiral.svg`, backgroundColor: 'rgba(247, 143, 84, 0.1)' },
];

export class SessionCategoryMapper {
  public static toModel(dto: SessionCategoryDto): SessionCategory {
    const i = dto.id % 3;
    return {
      id: dto.id,
      code: dto.code,
      title: dto.title,
      description: dto.description,
      position: dto.position,
      image: sessionCategoryStyling[i].image,
      backgroundColor: sessionCategoryStyling[i].backgroundColor,
      cover: dto.cover? ImageAssetMapper.toModel(dto.cover) : null,
    }
  }

  public static toCreateDto(model: SessionCategoryBase): SessionCategoryCreateDto {
    return {
      code: model.code,
      title: model.title,
      description: model.description,
      position: model.position,
      cover: model.cover ? ImageAssetMapper.toDto(model.cover) : undefined,
    }
  }

  public static toUpdateDto(model: SessionCategory): SessionCategoryUpdateDto {
    return {
      cover: model.cover ? ImageAssetMapper.toDto(model.cover) : undefined,
      position: model.position,
    }
  }
}